import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.4 12L0 10.6L4.6 6L0 1.4L1.4 0L7.4 6L1.4 12Z", fill: "#2D2D2D" }));
export default SvgChevronLeft;
